import script from "./FixedActions.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedActions.vue?vue&type=script&setup=true&lang=js"

import "./FixedActions.vue?vue&type=style&index=0&id=408e31cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408e31cf"]])

export default __exports__